import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { normalizeData } from '../../../../utils';
import { useScaleData } from '../useScaleData';
import styles from './index.styl';

const TestResultsScale = ({
  formatMessage,
  backgroundColors,
  points,
  edges,
  rangesPoints,
  height,
}) => {
  const { calculatedRanges, sumWidth, rangesPrefixSums } = useScaleData({
    rangesPoints,
  });

  return (
    <div className={styles.root}>
      <div className={styles.scale}>
        {calculatedRanges.map((range, index) => {
          if (range === 0) return;
          const widthInPercentage = (range / sumWidth) * 100;
          const width = `${widthInPercentage}%`;
          const rangeEndPointLeftPercentage =
            (rangesPrefixSums[index] / sumWidth) * 100;
          return (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`${range}-${index}`}
              style={{
                ...(index === 1 && {
                  borderTopLeftRadius: '4px',
                  borderBottomLeftRadius: '4px',
                }),
                ...(index === 2 && {
                  marginLeft: '2px',
                  marginRight: '2px',
                }),
                ...(index === 3 && {
                  borderTopRightRadius: '4px',
                  borderBottomRightRadius: '4px',
                }),
                height,
                width,
                background:
                  backgroundColors[(index - 1) % backgroundColors.length],
              }}
            >
              <div
                className={styles.rangeEndPointContainer}
                style={{ left: `${rangeEndPointLeftPercentage}%` }}
              >
                <div className={styles.rangeEndPointTextContainer}>
                  <span className={styles.rangeEndPointText}>
                    {edges &&
                    (index === 0 || index === calculatedRanges.length - 1) ? (
                      <Fragment>{edges[index === 0 ? 0 : 1]}</Fragment>
                    ) : (
                      <Fragment>
                        {rangesPoints
                          ? rangesPoints[index]
                          : rangesPrefixSums[index]}
                      </Fragment>
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        })}

        {points.map((point, index) => {
          const { value, marker } = point;
          const { pointValue, pointLeftPositionPercentage } = normalizeData(
            value,
            rangesPoints,
            sumWidth,
            calculatedRanges,
          );

          return (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`${pointValue}-${index}`}
              className={styles.pointContainer}
              style={{
                left: `${pointLeftPositionPercentage}%`,
              }}
            >
              {marker}
            </div>
          );
        })}
      </div>
      <div className={styles.subscriptionContainer}>
        <div>{formatMessage({ id: 'patient.portal.labTestResult.low' })}</div>
        <div>
          {formatMessage({ id: 'patient.portal.labTestResult.normal' })}
        </div>
        <div>{formatMessage({ id: 'patient.portal.labTestResult.high' })}</div>
      </div>
    </div>
  );
};

TestResultsScale.propTypes = {
  formatMessage: PropTypes.func,
  rangesPoints: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ),
  backgroundColors: PropTypes.arrayOf(PropTypes.string).isRequired,
  points: PropTypes.arrayOf(PropTypes.object).isRequired,
  edges: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ),
  height: PropTypes.number.isRequired,
};

export default TestResultsScale;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/TestResultsScale/index.jsx